import { Component, Input } from '@angular/core';
import { SvgImagesComponent } from '../svg-images/svg-images.component';
import { NgClass } from '@angular/common';

type banner =  'info' | 'warning' | 'danger';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [SvgImagesComponent, NgClass],
  template: `
    <div class="flex items-start p-4 mb-2 text-sm border rounded-lg" data-cy="banner" role="alert"
      [ngClass]="{
        'text-blue-800 border-blue-300 bg-blue-50': variant === 'info',
        'text-yellow-800 border-yellow-300 bg-yellow-50': variant === 'warning',
        'text-red-800 border-red-300 bg-red-50': variant === 'danger',
      }">
        <app-svg-images
          class="shrink-0 inline w-5 h-5 me-3"
          data-cy="banner-icon"
          [attr.data-name]="variant"
          [svgName]="variant === 'info' ? 'info-circle-solid' : 'exclamation-triangle-solid'">
        </app-svg-images>
      <span data-cy="banner-message">
        <ng-content></ng-content>
      </span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class BannerComponent {
  @Input() variant: banner = 'info';

}
